module.exports = __webpack_public_path__ + "img/Presta2.6712d878.png";